<template>
  <div class="row partner-box">
    <div class="col-xs-12 col-lg-3 partner-box-image text-center">
      <img :src="item.image" :title="item.name" />
    </div>
    <div class="col-xs-12 col-lg-9 text-left">
      <h4 class="partner-box-title">
        <a :href="item.link" target="_blank">
          {{ item.name }}
        </a>
      </h4>
      <p class="partner-box-text" v-html="item.description"></p>
    </div>
  </div>
</template>

<script>
export default {
	name: 'PartnerBox',
	props: {
		item: {
			type: Object,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PartnerBox.vue